export const maxSizeFile = (value) => {
  if (value) {
    return value.size <= 54194304
  }
  return true
}

export const allowedFileType = (value) => {
  if (value) {
    const type = value.name.split('.').pop()
    switch (true) {
      case type.startsWith('xls'):
      case type.startsWith('doc'):
      case type.startsWith('ppt'):
      case type === 'pdf':
      case type === 'png':
      case type === 'jpg':
      case type === 'jpeg':
        return true
      default:
        return false
    }
  }
  return true
}
